import { Trans, useTranslation } from 'react-i18next';
import Checkbox from 'components/Checkbox/Checkbox';
import EmptyList from 'components/EmptyList/EmptyList';
import { KEYS_FIELDS_CUSTOMER_MINI } from 'constants/materialAssessment';

import type ICustomerItem from 'store/slices/dataSets/interfaces/ICustomerItem';
import type IMiniTableBody from './interfaces/IMiniTableBody';

import styles from './scss/MiniTableBody.module.scss';

function MiniTableBody({
  vcCustomers,
  headerCellsMini,
  selectedItems,
  setSelectedItems,
}: Readonly<IMiniTableBody>) {
  const { t } = useTranslation();
  const emptyListText = (
    <Trans
      i18nKey="common.noResultsItems"
      t={t}
      components={{
        br: <br />,
      }}
    />
  );

  const renderMiniTableCell = (miniItem: ICustomerItem, cellId: string) => {
    switch (cellId) {
      case KEYS_FIELDS_CUSTOMER_MINI.CHECKBOX:
        return (
          <Checkbox
            key={miniItem.id}
            name={`${miniItem.name}-${miniItem.id}`}
            checked={selectedItems.includes(miniItem.id)}
            value={miniItem.id}
            onChange={() => setSelectedItems(miniItem.id)}
          />
        );
      case KEYS_FIELDS_CUSTOMER_MINI.CUSTOMER_NAME:
        return miniItem.name;
      case KEYS_FIELDS_CUSTOMER_MINI.CUSTOMER_SYSTEM_UNIQUE_IDENTIFIER:
        return miniItem.uniqueIdentifier;
      case KEYS_FIELDS_CUSTOMER_MINI.CUSTOMER_CODE:
        return miniItem.code;
      case KEYS_FIELDS_CUSTOMER_MINI.VALUE_CHAIN_POSITION:
        return miniItem.valueChainSection;
      case KEYS_FIELDS_CUSTOMER_MINI.UPSTREAM_TIER:
        return miniItem.ownership;
      case KEYS_FIELDS_CUSTOMER_MINI.OWNERSHIP:
        return miniItem.ownership;
      default:
        return '';
    }
  };

  return (
    <div className={styles.miniTableBody}>
      {vcCustomers.length > 0 ? vcCustomers.map((miniItem) => (
        <div key={miniItem.id} className={styles.miniTableRow}>
          {headerCellsMini.map((cell) => (
            <div
              key={cell.id}
              className={`${styles.miniTableCell} ${
                cell.id === KEYS_FIELDS_CUSTOMER_MINI.CHECKBOX ? styles.checkboxColumn : ''
              }`}
            >
              {renderMiniTableCell(miniItem, cell.id)}
            </div>
          ))}
        </div>
      )) : (
        <div className={styles.miniTableRow}>
          <EmptyList text={emptyListText} />
        </div>
      )}
    </div>
  );
}

export default MiniTableBody;
